module.exports = __webpack_public_path__ + "static/img/mkv.993626a3.png";